<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">试客佣金服务配置</span>
    </div>
    <el-tabs class="el-tabs-self" v-model="tabsActive">
      <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.taskName" :name="item.id"></el-tab-pane>
    </el-tabs>
    <money-table-data :selectMenuValue="selectMenuValue"></money-table-data>
  </el-card>
</div>
</template>

<script>
import MoneyTableData from "@/components/MoneyTableData";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";

export default {
  name: "CustomChargesSetting",
  components:{
    MoneyTableData
  },
  data(){
    return {
      tabsActive: 1,
      tabsActives: []
    }
  },
  mounted() {
    getAllTaskType().then(res => {
      console.log(res.data)
      this.tabsActives = res.data;
    });
  },
  computed: {
    selectMenuValue(){
      return this.tabsActives.filter(item => item.id == this.tabsActive).pop();
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
}
</style>
